'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002411 from "./presto.-Register-Page-View$$anon$11.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002413 from "./presto.-Register-Page-View$$anon$13.js";
import * as $j_presto$002etypes$0024$002dCompact$002dPlan$0024 from "./presto.types$-Compact-Plan$.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$10() {
  this.bta = null;
  this.bt2 = null;
  this.bt3 = false;
  this.btb = null;
  this.btc = false;
  this.btf = null;
  this.bt8 = null;
  this.bt9 = false;
  this.bt4 = null;
  this.bt5 = false;
  this.bt6 = null;
  this.bt7 = false;
  this.btd = false;
  this.bte = false;
  this.bta = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.btf = "CompactPlan";
}
export { $c_Lpresto_RegisterPageView$$anon$10 as $c_Lpresto_RegisterPageView$$anon$10 };
$p = $c_Lpresto_RegisterPageView$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$10;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$10() {
}
export { $h_Lpresto_RegisterPageView$$anon$10 as $h_Lpresto_RegisterPageView$$anon$10 };
$h_Lpresto_RegisterPageView$$anon$10.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bta;
});
$p.L = (function() {
  if ((!this.bt3)) {
    this.bt2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bt3 = true;
  }
  return this.bt2;
});
$p.O = (function() {
  if ((!this.btc)) {
    this.btb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.btc = true;
  }
  return this.btb;
});
$p.E = (function() {
  return this.btf;
});
$p.t = (function() {
  if ((!this.bt9)) {
    this.bt8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("features", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bt9 = true;
  }
  return this.bt8;
});
$p.M = (function() {
  if ((!this.bt5)) {
    this.bt4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().adv(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002411.$c_Lpresto_RegisterPageView$$anon$11())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bt5 = true;
  }
  return this.bt4;
});
$p.Q = (function() {
  if ((!this.bt7)) {
    this.bt6 = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002413.$c_Lpresto_RegisterPageView$$anon$13();
    this.bt7 = true;
  }
  return this.bt6;
});
$p.w = (function() {
  if ((!this.bte)) {
    this.btd = false;
    this.bte = true;
  }
  return this.btd;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee96) => ((p) => \u03b4scrutinee96.ada(p)))($j_presto$002etypes$0024$002dCompact$002dPlan$0024.$m_Lpresto_types$CompactPlan$())));
});
var $d_Lpresto_RegisterPageView$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$10, "presto.RegisterPageView$$anon$10", ({
  PS: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$10 as $d_Lpresto_RegisterPageView$$anon$10 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$10.js.map
